import '../../../lib/filebrowser/src/css/styles.css'
import FilebrowserHeader from '../../../lib/filebrowser/src/components/Header'

export default {
  extends: FilebrowserHeader
}